import axios from '../../utils/axios'
import cookies from './cookies'
import { logout } from '../actions/auth.action'
import { updateTimer, removeTimer } from '../actions/session.action'

const callApi = (url, method, body = {}, config = {}, rawResponse = false) => {
	let params = {
		method,
		...config,
		data: body
	}
	if (method === 'GET') {
		delete params.data
	}

	return (dispatch, timeout = false, withoutAuth = false) => {
		dispatch(updateTimer())
		return new Promise((resolve, reject) => {
			if (!withoutAuth && !cookies.load('authToken')) {
				dispatch(logout())
				reject(new Error('Unauthorized!'))
			}
			if (timeout) setTimeout(() => reject(new Error('Connection Timeout!')), 30 * 1000)
			axios(url, params).then(resolve, reject)
		})
			.then((res) => {
				if ([200, 401].includes(res.status)) {
					if (res.status === 401) {
						dispatch(logout(true))
						dispatch(removeTimer())
					}
					return res.data
				}
				else throw new Error(res.status === 500 ? 'Something went wrong! Please try again leter' : res.status === 429 ? 'Too many requests! Plaese try again leter' : res.statusText)
			})
			.then(res => {
				if(rawResponse) return res;
				if (['stream', 'blob'].includes(config.responseType)) return res
				else if (res.data) {
					return res.data
				} else if (res.error) {
					let msg = res.error?.messages && res.error?.messages[0]
					throw new Error(msg)
				} else throw new Error(res.status)
			})
			.catch(err => {
				if (err?.response?.status === 403 || err?.response?.status === 401) {
					dispatch(logout())
					dispatch(removeTimer())
				}
				throw new Error(err.message)
			})
	}
}


export default {
	get: (url, config, rawResponse=false) => callApi(url, 'GET', {}, config, rawResponse),
	post: (url, body, config, rawResponse= false) => callApi(url, 'POST', body, config, rawResponse),
	patch: (url, body, config) => callApi(url, 'PATCH', body, config),
	put: (url, body, config) => callApi(url, 'PUT', body, config),
	delete: (url, body, config) => callApi(url, 'DELETE', body, config),
}